module.exports = __webpack_public_path__ + "img/sam-rodriguez-nectar.db11de0.jpg";